var CuiBaseComponent = /** @class */ (function () {
    function CuiBaseComponent() {
        this.subscriptions = [];
    }
    CuiBaseComponent.prototype.pushSubscription = function () {
        var _this = this;
        var subscriptions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            subscriptions[_i] = arguments[_i];
        }
        subscriptions.forEach(function (subscription) { return _this.subscriptions.push(subscription); });
    };
    CuiBaseComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    return CuiBaseComponent;
}());
export { CuiBaseComponent };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/shared/base-component.ts.pre-build-optimizer.js